import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';

var SeFeToastTypes;
(function (SeFeToastTypes) {
    SeFeToastTypes["Error"] = "error";
    SeFeToastTypes["Info"] = "info";
    SeFeToastTypes["Success"] = "success";
    SeFeToastTypes["Warning"] = "warning";
})(SeFeToastTypes || (SeFeToastTypes = {}));
class SeFeToastService {
    constructor() {
        this.events = new BehaviorSubject(null);
        this.seFeToastSvgPath = {
            info: 'M12,2 C6.5,2 2,6.5 2,12 C2,17.5 6.5,22 12,22 C17.5,22 22,17.5 22,12 C22,6.5 17.5,2 12,2 Z M10.75,16.75 L10.75,12 C10.75,11.3096441 11.3096441,10.75 12,10.75 L12,10.75 C12.6903559,10.75 13.25,11.3096441 13.25,12 L13.25,16.75 C13.25,17.4403559 12.6903559,18 12,18 L12,18 C11.3096441,18 10.75,17.4403559 10.75,16.75 Z M12,8.5 C11.25,8.5 10.75,8 10.75,7.25 C10.75,6.5 11.25,6 12,6 C12.75,6 13.25,6.5 13.25,7.25 C13.25,8 12.75,8.5 12,8.5 Z',
            success: 'M10,0 C15.5,0 20,4.5 20,10 C20,15.5 15.5,20 10,20 C4.5,20 0,15.5 0,10 C0,4.5 4.5,0 10,0 Z M13.4321609,6.86073232 L8.57142857,11.7214646 L6.5678391,9.71787518 C6.08686267,9.23689875 5.34170876,9.23689875 4.86073232,9.71787518 C4.37975589,10.1988516 4.37975589,10.9440055 4.86073232,11.424982 L7.71787518,14.2821248 C7.95861094,14.5228606 8.22860321,14.6428571 8.57142857,14.6428571 C8.91425393,14.6428571 9.18424621,14.5228606 9.42498196,14.2821248 L15.1392677,8.5678391 C15.6202441,8.08686267 15.6202441,7.34170876 15.1392677,6.86073232 C14.6582912,6.37975589 13.9131373,6.37975589 13.4321609,6.86073232 Z',
            warning: 'M20.9059614,18.8109024 C21.0393252,19.0623487 21.0303252,19.3648953 20.8822341,19.6082305 C20.734143,19.8515656 20.4690518,20 20.1818697,20 L3.81821592,20 C3.53103379,20 3.2659426,19.8515656 3.11703335,19.6074193 C2.96976047,19.3648953 2.96076046,19.0623487 3.09412424,18.8109024 L11.2759511,3.39967794 C11.5590423,2.86677402 12.4410433,2.86677402 12.7241345,3.39967794 L20.9059614,18.8109024 Z M10.75,13.5 C10.75,14.1903559 11.3096441,14.75 12,14.75 C12.6903559,14.75 13.25,14.1903559 13.25,13.5 L13.25,9.25 C13.25,8.55964406 12.6903559,8 12,8 C11.3096441,8 10.75,8.55964406 10.75,9.25 L10.75,13.5 Z M12,18.5 C12.75,18.5 13.25,18 13.25,17.25 C13.25,16.5 12.75,16 12,16 C11.25,16 10.75,16.5 10.75,17.25 C10.75,18 11.25,18.5 12,18.5 Z',
            error: 'M20.9059614,18.8109024 C21.0393252,19.0623487 21.0303252,19.3648953 20.8822341,19.6082305 C20.734143,19.8515656 20.4690518,20 20.1818697,20 L3.81821592,20 C3.53103379,20 3.2659426,19.8515656 3.11703335,19.6074193 C2.96976047,19.3648953 2.96076046,19.0623487 3.09412424,18.8109024 L11.2759511,3.39967794 C11.5590423,2.86677402 12.4410433,2.86677402 12.7241345,3.39967794 L20.9059614,18.8109024 Z M10.75,13.5 C10.75,14.1903559 11.3096441,14.75 12,14.75 C12.6903559,14.75 13.25,14.1903559 13.25,13.5 L13.25,9.25 C13.25,8.55964406 12.6903559,8 12,8 C11.3096441,8 10.75,8.55964406 10.75,9.25 L10.75,13.5 Z M12,18.5 C12.75,18.5 13.25,18 13.25,17.25 C13.25,16.5 12.75,16 12,16 C11.25,16 10.75,16.5 10.75,17.25 C10.75,18 11.25,18.5 12,18.5 Z',
        };
    }
    addToast(config) {
        this.events.next(config);
        this.events.next(null);
    }
    // CONVENIENCE METHODS (these also match SeToast)
    error(message) {
        this.addToast({ message, type: SeFeToastTypes.Error });
    }
    info(message) {
        this.addToast({ message, type: SeFeToastTypes.Info });
    }
    success(message) {
        this.addToast({ message, type: SeFeToastTypes.Success });
    }
    warning(message) {
        this.addToast({ message, type: SeFeToastTypes.Warning });
    }
}
SeFeToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SeFeToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });
const ToastService = SeFeToastService;

const SHOW_DURATION = 4000;
const HIDE_DELAY = 2000;
const HIDE_DURATION = 200;
class SeFeToastComponent {
    constructor(seFeToastService) {
        this.seFeToastService = seFeToastService;
        this.config = new BehaviorSubject(null);
        this.configQueue = [];
        //noop
    }
    ngOnInit() {
        this.subscription = this.seFeToastService.events.subscribe(toastConfig => {
            this.configQueue.push(toastConfig);
            if (toastConfig === undefined)
                this.hideToast();
            if (!this.timer)
                this.showToast();
        });
    }
    hideToastDelay() {
        setTimeout(() => this.hideToast(), HIDE_DELAY);
    }
    clearTimer() {
        clearTimeout(this.timer);
        this.timer = undefined;
    }
    get svgPath() {
        return this.seFeToastService.seFeToastSvgPath[this.config.value.type];
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    showToast() {
        if (this.configQueue.length === 0) {
            this.clearTimer();
            return;
        }
        this.config.next(this.configQueue[0]);
        this.timer = setTimeout(() => this.hideToast(), SHOW_DURATION);
    }
    hideToast() {
        this.config.next(undefined);
        this.configQueue.shift();
        setTimeout(() => this.showToast(), HIDE_DURATION);
    }
}
SeFeToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastComponent, deps: [{ token: SeFeToastService }], target: i0.ɵɵFactoryTarget.Component });
SeFeToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeToastComponent, selector: "se-fe-toast", ngImport: i0, template: "\n<div [@slideInOut] class=\"se-fe-toast\" *ngIf=\"config | async as toast\">\n  <div \n    (mouseenter)=\"clearTimer()\"\n    (mouseleave)=\"hideToastDelay()\"\n    role=\"alert\"\n    class=\"se-fe-toast-item se-fe-toast-item--{{ toast.type }}\">\n    <svg class=\"se-fe-toast-item__icon se-fe-toast-item--{{ toast.type }}_icon\" xmlns=\"http://www.w3.org/2000/svg\"\n      xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" width=\"24\"\n      preserveAspectRatio=\"xMidYMid meet\"aria-hidden=\"true\">\n      <path stroke-width=\"0\" [attr.d]=\"this.svgPath\"></path>\n    </svg>\n    <div class=\"se-fe-toast-item__message\">\n      {{ toast.message }}\n    </div>\n  </div>\n</div>\n", styles: [".se-fe-toast{bottom:16px;max-width:calc(100vw - 48px);position:fixed;right:16px;width:296px;z-index:999}@media (min-width: 600px){.se-fe-toast{bottom:24px;right:24px}}.se-fe-toast-item{align-items:center;border-radius:2px;border:1px solid;box-shadow:0 2px 4px #0003,0 1px 10px #0000001f,0 4px 5px #00000024;display:flex;flex-wrap:nowrap;padding:16px}.se-fe-toast-item--error{background:#fbf2f4;border-color:#b42846}.se-fe-toast-item--info{background:#e6f8ff;border-color:#00668f}.se-fe-toast-item--success{background:#f0faf4;border-color:#00a846}.se-fe-toast-item--warning{background:#fefbf2;border-color:#f0b428}.se-fe-toast-item--error_icon{align-self:flex-start;fill:#b42846;flex:0 0 auto}.se-fe-toast-item--info_icon{align-self:flex-start;fill:#00668f;flex:0 0 auto}.se-fe-toast-item--success_icon{align-self:flex-start;fill:#00a846;flex:0 0 auto}.se-fe-toast-item--warning_icon{align-self:flex-start;fill:#f0b428;flex:0 0 auto}.se-fe-toast-item__message{color:#23282b;flex:1 1 100%;font-size:calc(var(--se-rem, 1rem) * 1);margin-left:8px;overflow-wrap:break-word;overflow:hidden;text-align:left}.se-fe-toast-item__message{word-break:break-word}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i2.AsyncPipe }, animations: [
        trigger('slideInOut', [
            transition(':enter', [style({ height: 0 }), animate('100ms ease-in-out')]),
            transition(':leave', [animate('100ms ease-in', style({ height: 0 }))]),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-toast',
                    templateUrl: './se-fe-toast.component.html',
                    styleUrls: ['./se-fe-toast.component.scss'],
                    animations: [
                        trigger('slideInOut', [
                            transition(':enter', [style({ height: 0 }), animate('100ms ease-in-out')]),
                            transition(':leave', [animate('100ms ease-in', style({ height: 0 }))]),
                        ]),
                    ],
                }]
        }], ctorParameters: function () { return [{ type: SeFeToastService }]; } });

class SeFeToastModule {
}
SeFeToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastModule, declarations: [SeFeToastComponent], imports: [CommonModule], exports: [SeFeToastComponent] });
SeFeToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeToastComponent],
                    imports: [CommonModule],
                    exports: [SeFeToastComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeToastComponent, SeFeToastModule, SeFeToastService, SeFeToastTypes, ToastService };
